import React from 'react';
import { Marquee } from './marquee';



// ── Info cards: Row 1 — Capacidades do sistema
const infoRow1 = [
    { icon: 'bolt', label: 'Resposta rápida', value: '< 10s', desc: 'Latência média via OpenAI API' },
    { icon: 'schedule', label: 'Disponível', value: '24/7', desc: 'IA ativa fora do horário comercial' },
    { icon: 'forum', label: 'Canais', value: 'WA + IG', desc: 'Gerencia WhatsApp e Instagram no mesmo painel' },
    { icon: 'psychology', label: 'Motor de IA', value: 'OpenAI', desc: 'Respostas geradas com a mesma potência que o GPT' },
    { icon: 'monitoring', label: 'Painel', value: 'Ao vivo', desc: 'Conversas e métricas em tempo real' },
];

// ── Info cards: Row 2 — Resultados e funcionalidades
const infoRow2 = [
    { icon: 'trending_up', label: 'Conversão', value: '+200%', desc: 'Média observada nos primeiros 30 dias' },
    { icon: 'support_agent', label: 'Atendente', value: 'Handoff', desc: 'Transfere para humano quando necessário' },
    { icon: 'filter_alt', label: 'Qualificação', value: 'Automática', desc: 'Leads capturados e filtrados pelo bot' },
    { icon: 'lock', label: 'Privacidade', value: 'Segura', desc: 'Dados protegidos' },
    { icon: 'rocket_launch', label: 'Implantação', value: '1 dia', desc: 'Do contrato ao bot funcionando' },
];


function InfoCard({ icon, label, value, desc }) {
    return (
        <div className="relative w-52 h-40 shrink-0 cursor-pointer overflow-hidden rounded-xl border border-white/[.08] bg-white/[.06] hover:bg-white/[.12] p-4 transition-all duration-300 mx-2 group/card text-center">
            {/* Glow accent */}
            <div className="absolute -top-4 -right-4 w-16 h-16 rounded-full blur-2xl bg-primary/20 opacity-0 group-hover/card:opacity-100 transition-opacity duration-500" />
            <div className="flex flex-col items-center gap-1 mb-3">
                <span className="material-symbols-outlined text-primary text-[20px]">{icon}</span>
                <span className="text-[10px] font-semibold uppercase tracking-widest text-white/40 text-center">{label}</span>
            </div>
            <p className="text-lg font-bold text-white leading-tight">{value}</p>
            <p className="text-xs text-white/55 leading-relaxed mt-1 line-clamp-2">{desc}</p>
        </div>
    );
}

export function MarqueeHorizontalBg() {
    return (
        <div className="absolute inset-0 flex flex-col items-center justify-center overflow-hidden gap-3 py-2">
            <Marquee pauseOnHover repeat={4} gap="0px" className="[--duration:30s]">
                {infoRow1.map((r) => <InfoCard key={r.label} {...r} />)}
            </Marquee>
            <Marquee reverse pauseOnHover repeat={4} gap="0px" className="[--duration:30s]">
                {infoRow2.map((r) => <InfoCard key={r.label} {...r} />)}
            </Marquee>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-surface to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-surface to-transparent" />
        </div>
    );
}

// ══════════════════════════════════════════════════════════════════════════════
// VERTICAL — Casos de uso / situações que o PapIA resolve (card "200% de Conversão")
// ══════════════════════════════════════════════════════════════════════════════
const useCases = [
    { logo: '/logos/samaringa.jpg', title: 'S.A Maringá', instagram: '@sacasadesushimaringa', desc: 'Automatizei completamente meu whatsapp, recomendo.' },
    { logo: '/logos/saaltodaxv.jpg', title: 'S.A Alto da XV', instagram: '@sacasadosushialtodaxv', desc: 'Meus leads subiram muito, gostei.' },
    { logo: '/logos/budega.jpg', title: 'Budega do Vizinho', instagram: '@budegadovizinho', desc: 'Não dava conta do Instagram mas agora tenho tempo de sobra.' },
    { logo: '/logos/kanoa.jpg', title: 'Kanoa Sushi', instagram: '@kanoa_sushi_', desc: 'A IA responde tudo! Nem preciso me preocupar com o whats.' },
];

const useCasesCol1 = useCases.slice(0, 2);
const useCasesCol2 = useCases.slice(2);

function UseCaseCard({ logo, title, instagram, desc }) {
    return (
        <div className="w-44 h-44 shrink-0 overflow-hidden cursor-pointer rounded-xl border border-white/[.08] bg-white/[.06] hover:bg-white/[.10] p-4 transition-colors duration-300 my-2">
            <img
                src={logo}
                alt={title}
                width="40"
                height="40"
                className="rounded-full mb-2 object-cover"
            />
            <p className="text-sm font-semibold text-white leading-snug">{title}</p>
            {instagram && (
                <p className="text-[10px] text-white/40 mt-0.5">{instagram}</p>
            )}
            <p className="text-xs text-white/55 leading-relaxed mt-1.5">{desc}</p>
        </div>
    );
}

export function MarqueeVerticalBg() {
    return (
        <div className="absolute inset-0 flex flex-row items-center justify-center overflow-hidden gap-2 px-2">
            <Marquee pauseOnHover vertical repeat={5} gap="0px" className="[--duration:20s]">
                {useCasesCol1.map((u) => <UseCaseCard key={u.title} {...u} />)}
            </Marquee>
            <Marquee reverse pauseOnHover vertical repeat={5} gap="0px" className="[--duration:20s]">
                {useCasesCol2.map((u) => <UseCaseCard key={u.title} {...u} />)}
            </Marquee>
            <div className="pointer-events-none absolute inset-x-0 top-0 h-12 bg-gradient-to-b from-surface to-transparent" />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-surface to-transparent" />
        </div>
    );
}
